import axios from "axios"

let http = axios.create({
    baseURL: 'https://hd.api.jshhkjc.cn',
    timeout: 5000
})

// 添加响应拦截器处理常见错误
http.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        console.error('API请求错误:', error);
        // 根据错误类型给出不同的提示
        if (error.code === 'ECONNABORTED') {
            console.error('请求超时');
        } else if (!error.response) {
            console.error('网络连接失败');
        }
        return Promise.reject(error);
    }
);

export default http
